import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isTransparent = !scrolled && !mobileOpen;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || mobileOpen
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-black/20 backdrop-blur-sm"
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link
            to="/"
            onClick={() => setMobileOpen(false)}
            className="flex items-center gap-2 cursor-pointer"
          >
            <span
              className={`font-heading text-xl font-semibold whitespace-nowrap transition-colors ${
                isTransparent ? "text-white" : "text-foreground-950"
              }`}
            >
              AllChinaBuy<span className={isTransparent ? "text-primary-300" : "text-primary-500"}>Spreadsheet</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isTransparent ? "text-white/85 hover:text-white" : "text-foreground-600 hover:text-primary-500"
              }`}
            >
              Home
            </Link>
            <Link
              to="/allchinabuyspreadsheet-guide"
              className={`text-sm transition-colors whitespace-nowrap cursor-pointer ${
                isTransparent ? "text-white/85 hover:text-white" : "text-foreground-600 hover:text-primary-500"
              }`}
            >
              Shopping Guide
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className={`text-sm transition-colors whitespace-nowrap cursor-pointer ${
                isTransparent ? "text-white/85 hover:text-white" : "text-foreground-600 hover:text-primary-500"
              }`}
            >
              AllChinaBuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-md bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="Toggle menu"
          >
            <i
              className={`text-xl transition-colors ${
                isTransparent ? "text-white" : "text-foreground-800"
              } ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}
            ></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/70 py-4 pb-6 bg-background-50">
            <div className="flex flex-col gap-1">
              <Link
                to="/"
                onClick={() => setMobileOpen(false)}
                className="flex items-center gap-3 px-3 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-home-4-line text-lg text-foreground-400"></i>
                Home
              </Link>
              <Link
                to="/allchinabuyspreadsheet-guide"
                onClick={() => setMobileOpen(false)}
                className="flex items-center gap-3 px-3 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-book-open-line text-lg text-foreground-400"></i>
                Shopping Guide
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-3 px-3 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-external-link-line text-lg text-foreground-400"></i>
                AllChinaBuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 mt-2 mx-3 py-3 text-sm font-semibold rounded-lg bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-shopping-bag-3-line"></i>
                Buy It Now
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}